<template>
    <div>
    <div class="row">
        <div class="col-lg-4">

            <base-input alternative=""
                        required
                        :disabled = "!question.edit"
                        label="Frage"
                        placeholder="Geben Sie hier die Frage ein"
                        input-classes="form-control-alternative"
                        v-model="question.question"
            />
        </div>
        <div class="col-lg-4">
            <base-input alternative=""
                        :disabled = "!question.edit"
                        label="Beschreibung"
                        placeholder="Ergänzende Informationen zur Frage (optional)"
                        input-classes="form-control-alternative"
                        v-model="question.description"
            />
        </div>
        <div class="col-lg-2">
            <label class="form-control-label">
                Art der Frage
            </label>
            <b-form-select :disabled = "!question.edit" v-model="question.type" :options="options" class="mb-3"></b-form-select>
        </div>
        <div class="col-lg-2 text-center">
            <label class="form-control-label">
                `sonstiges` Feld?
            </label><br>
            <!---- https://github.com/drewjbartlett/vue-switches --->
            <switches :disabled = "!question.edit" style="margin-top: 0.8rem;" theme="bootstrap" color="primary" type-bold="true"
                      v-model="question.extra"></switches>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <label class="form-control-label">
                Antwortmöglichkeiten
            </label>
            <b-form-tags input-id="tags-basic"
                         v-model="question.answers"
                         :disabled = "!question.edit"
                         placeholder="Antworten hier eingeben und mit Enter abschließen"
                         tag-variant="primary"
                         size="lg"
                         @tag-state="onTagState"
                         class="mb-2"
            ></b-form-tags>
        </div>
    </div>
        <div class="row">
            <div :key="tick+'qfsmr'" class="col-lg-12">
                <label class="form-control-label">
                    Regeln zum Ausführen von Spielerschutzmaßnahmen
                </label><br>
                <a v-if="question.edit" href="#" @click.prevent="createRule(question)">hinzufügen</a>


                <base-table v-if="(question.rules)" class="table align-items-center table-flush"
                            thead-classes="thead-light"
                            tbody-classes="list"
                            :data="question.rules">
                    <template slot="columns">
                        <th>Value</th>
                        <th>Action</th>
                        <th></th>
                    </template>

                    <template slot-scope="{row}">
                        <th scope="row" >
                           <span v-if="!question.edit">{{row.value}}</span>
                            <base-input v-else v-model="row.value" class="mb-1" input-classes="form-control"></base-input>
                        </th>
                        <td >
                            <span v-if="!question.edit">{{$store.getters['actions/showActionByIRI']('/api/actions/'+row.action).name}}</span>
                            <select v-else v-model="row.action"
                                    class="mb-1 custom-select form-control">
                                <option v-for="action in actions" :key="action.id" :value="action.id">({{ action.id }}) {{ action.name }}
                                </option>
                            </select>
                        </td>
                        <td>
                            <base-button v-on:click="question.rules.splice(question.rules.indexOf(row.id),1)" icon="fa fa-trash" type="secondary" icon-only
                                         title="löschen"></base-button>
                        </td>
                    </template>
                </base-table>
            </div>
        </div>
    </div>
</template>
<script>
    import Switches from "vue-switches"

    export default {
        name: 'Questionform',
        components: {Switches},
        props: {
            question: { rules: []},
            socialconcept: null
        },
        data() {
            return {

                options: [
                    {value: 'number', text: 'Zahlen'},
                    {value: 'text', text: 'Text'},
                    {value: 'single', text: 'Single Choice'},
                    {value: 'multiple', text: 'multiple Choice'}
                ],
                validTags: [],
                invalidTags: [],
                duplicateTags: [],
                editable: [],
                tick: 1
            }
        },
        created() {
            if (!this.$store.getters['actions/isLoading'] && this.$store.getters['actions/isEmpty']) this.$store.dispatch('actions/getActionCollection');
        },
        computed: {
            actions(){
                return (!this.$store.getters['actions/isLoading'] && !this.$store.getters['actions/isEmpty']) ? Array.from(this.$store.getters['actions/showActionCollectionByConcept'](this.socialconcept)) : [{id: 0, name: ''}];
            },
        },
        methods: {
            onTagState(valid, invalid, duplicate) {
                this.validTags = valid;
                this.invalidTags = invalid;
                this.duplicateTags = duplicate;
            },
            createRule(question) {
                if(question.rules) {
                    question.rules.push({value: '', action: 1})
                } else {
                    question.rules = [{value: '', action: 1}];
                }
                this.tick++;
            }
        }
    }
</script>